const adaptTochkaRequestBody = (body) => ({
  pointId: body.pointId[0].id,
});

export default adaptTochkaRequestBody;
